import type { IPatient } from '../../../../common/interfaces/patient';
import type { IRequestGetOne } from '../../interfaces/requestGetOne';
import { ToastType } from '../../../../common/enums/toastType';
import { getDisplayName } from '../../../../common/utils/getDisplayName';
import { fetchJson } from '../../../store/fetch';
import { translateKey } from '../../../translate';
import { showServiceToast } from '../../../utils/showToast';
import { Button } from '../common';

interface IResendInvitationlButtonProps {
    patient: IPatient;
    reloadRequest: () => Promise<void>;
    request: IRequestGetOne;
}

export function ResendInvitationButton(props: IResendInvitationlButtonProps) {
    return (
        <Button
            automation="resendInvitation"
            color="secondary"
            large
            onClick={async () => {
                await fetchJson(`/api/requests/${props.request.id}/resendInvite`, 'POST', {
                    email: props.patient.emailAddress,
                });
                showSuccessToast();
                await props.reloadRequest();
            }}
        >
            {translateKey('diagnosticReport.resend')}
        </Button>
    );

    function showSuccessToast() {
        const toastMessage = `Het onderzoek is verstuurd naar ${getDisplayName(props.patient)}`;
        showServiceToast(ToastType.success, undefined, undefined, 'request', toastMessage);
    }
}
